export default __webpack_public_path__ + "static/media/clonee.f5a0eb3e.svg";